var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { NavLink as ThemeUILink, } from 'theme-ui';
ThemeUILink.defaultProps = {
    sx: {
        color: 'baseText',
        textDecoration: 'none',
    },
};
const Link = forwardRef((_a, ref) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(ThemeUILink, Object.assign({ ref: ref }, rest, { children: children })));
});
export default Link;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbW1vbnMvTGluay9MaW5rLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ25DLE9BQU8sRUFDTCxPQUFPLElBQUksV0FBVyxHQUd2QixNQUFNLFVBQVUsQ0FBQztBQUlsQixXQUFXLENBQUMsWUFBWSxHQUFHO0lBQ3pCLEVBQUUsRUFBRTtRQUNGLEtBQUssRUFBRSxVQUFVO1FBQ2pCLGNBQWMsRUFBRSxNQUFNO0tBQ3ZCO0NBQ0YsQ0FBQztBQU1GLE1BQU0sSUFBSSxHQUE2QyxVQUFVLENBQy9ELENBQUMsRUFBcUIsRUFBRSxHQUFHLEVBQUUsRUFBRTtRQUE5QixFQUFFLFFBQVEsT0FBVyxFQUFOLElBQUksY0FBbkIsWUFBcUIsQ0FBRjtJQUFZLE9BQUEsQ0FDOUIsS0FBQyxXQUFXLGtCQUFDLEdBQUcsRUFBRSxHQUFHLElBQU0sSUFBSSxjQUM1QixRQUFRLElBQ0csQ0FDZixDQUFBO0NBQUEsQ0FDRixDQUFDO0FBQ0YsZUFBZSxJQUFJLENBQUMifQ==